import React from 'react';

/**
 * iOS-style ON/OFF toggle switch.
 * @param {boolean} checked - of de toggle aan staat
 * @param {function} onChange - callback bij click
 * @param {string} size - 'sm' (default) | 'md' | 'lg'
 * @param {string} label - optioneel label rechts van de toggle
 * @param {boolean} showLabel - toon ON/OFF tekst (default true)
 * @param {string} onColor - CSS kleur voor 'aan'-stand (default groen)
 */
export default function IOSToggle({ checked, onChange, size = 'sm', label, showLabel = true, onColor = '#16A34A', disabled = false, testid, ariaLabel }) {
  const dims = {
    sm: { w: 32, h: 16, thumb: 12, thumbOn: 18, thumbOff: 2 },
    md: { w: 40, h: 20, thumb: 16, thumbOn: 22, thumbOff: 2 },
    lg: { w: 52, h: 28, thumb: 24, thumbOn: 26, thumbOff: 2 },
  }[size] || { w: 32, h: 16, thumb: 12, thumbOn: 18, thumbOff: 2 };

  return (
    <button
      type="button"
      onClick={(e) => { if (disabled) return; e.stopPropagation(); onChange(!checked); }}
      className={`inline-flex items-center gap-1.5 select-none ${disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'}`}
      data-testid={testid}
      disabled={disabled}
      role="switch"
      aria-label={ariaLabel || label}
      aria-checked={checked}
    >
      <span
        className="relative inline-block rounded-full transition-colors"
        style={{
          width: dims.w,
          height: dims.h,
          background: checked ? onColor : '#D1D5DB',
        }}
      >
        <span
          className="absolute top-1/2 -translate-y-1/2 bg-white rounded-full shadow transition-all"
          style={{
            width: dims.thumb,
            height: dims.thumb,
            left: checked ? dims.thumbOn : dims.thumbOff,
          }}
        />
      </span>
      {showLabel && (
        <span className="text-[9px] font-bold tracking-wider" style={{ color: checked ? onColor : '#9CA3AF' }}>
          {checked ? 'ON' : 'OFF'}
        </span>
      )}
      {label && <span className="text-xs font-medium text-gray-700">{label}</span>}
    </button>
  );
}
